// 管理员认证
<template>
  <div>
    <div class="contentList">
      <el-empty :image="emptyImg" v-if="currAdminInfo.length <= 0"></el-empty>
      <template v-for="(val, idx) in currAdminInfo">
        <div
          style="
            padding: 0 5%;
            margin: 0.3rem auto 0.2rem;
            border-bottom: 1px solid #e4e7ed;
            position: relative;
          "
          :key="idx"
        >
          <el-row :gutter="50">
            <el-col :span="9">
              <el-form ref="form" :disabled="true" label-width="80px">
                <el-form-item label="用户名:">
                  <el-input v-model="val.userName"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名:">
                  <el-input v-model="val.name"></el-input>
                </el-form-item>
                <el-form-item label="联系方式:">
                  <el-input v-model="val.phone"></el-input>
                </el-form-item>
                <el-form-item label="认证学校:">
                  <el-input v-model="val.schoolName"></el-input>
                </el-form-item>
                <!-- <el-form-item label="职业:">
                  <el-input v-model="val.job"></el-input>
                </el-form-item> -->
                <el-form-item label="管理员类型:">
                  <!-- <el-input v-model="val.type"></el-input> -->
                  <span>{{
                    val.type == 1 ? "个人" : val.type == 2 ? "教职工" : "未知"
                  }}</span>
                </el-form-item>
                <!-- <el-form-item label="审核人:">
                  <p>{{ val.updateUser }}</p>
                </el-form-item> -->
                <el-form-item label="审核状态:">
                  <!-- <p v-if="val.state == 1" style="color: #0f0">通过</p>
                  <p v-if="val.state == 2" style="color: #f00">未通过</p> -->
                  <p style="color: #198cff" v-if="val.state == 0">待审核</p>

                  <p style="color: #2ee12e" v-if="val.state == 1">已认证</p>
                  <p style="color: #ea2727" v-if="val.state == 2">未通过</p>
                </el-form-item>
                <el-form-item label="审核时间:" v-if="val.state != 0">
                  <el-input v-model="val.updateTime"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="15">
              <el-form ref="form" :disabled="true" label-width="80px">
                <el-form-item label="身份证:">
                  <el-row :gutter="50">
                    <el-col :span="7">
                      <el-image
                        class="car"
                        :src="apiUrl + val.imgFront"
                        :preview-src-list="[apiUrl + val.imgFront]"
                      >
                        <div slot="error" class="el-image__error">
                          {{ !val.imgFront ? "暂无图片" : "加载失败" }}
                        </div>
                      </el-image>
                    </el-col>
                    <el-col :span="7">
                      <el-image
                        class="car"
                        :src="apiUrl + val.imgReverse"
                        :preview-src-list="[apiUrl + val.imgReverse]"
                      >
                        <div slot="error" class="el-image__error">
                          {{ !val.imgReverse ? "暂无图片" : "加载失败" }}
                        </div>
                      </el-image>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="个人工作证明:">
                  <el-row :gutter="50">
                    <el-col :span="7">
                      <el-image
                        class="car"
                        :src="apiUrl + val.imgWork"
                        :preview-src-list="[apiUrl + val.imgWork]"
                      >
                        <div slot="error" class="el-image__error">
                          {{ !val.imgWork ? "暂无图片" : "加载失败" }}
                        </div>
                      </el-image>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <img
            v-if="val.state == 1"
            class="judImg"
            src="../../assets/images/isAudit.png"
            alt=""
          />
          <img
            v-if="val.state == 2"
            class="judImg"
            src="../../assets/images/noAudit.png"
            alt=""
          />
          <img
            v-if="val.state == 0"
            class="judImg"
            src="../../assets/images/audit.png"
            alt=""
          />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currAdminInfo"],
  data() {
    return {
      emptyImg: require("../../assets/images/emptyImg.png"),
      apiUrl: "",
      list_ZloHYvTf: [0, 0, 0],
      currentPage: 1,
      userData: {},
    };
  },
  created() {
    this.apiUrl = window.api.apiurl;
    console.log(this.apiUrl);
  },
  mounted() {},
  methods: {
    //查看大图
    seeDetials(url) {
      window.open(`${this.apiUrl}${url}`);
    },
  },
};
</script>
<style lang="scss" scoped>
>>> .el-input__inner {
  color: #303133 !important;
  border: none !important;
  background: none !important;
  cursor: default !important;
}

.contentList {
  img.car {
    border: 1px solid #dedede;
    width: 100%;
    background: #eeeeee;
    box-sizing: border-box;
    border-radius: 0.05rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/userDetail/admin.vue